import styles from "./loginForm.module.css";
import { Alert, Button } from "@mui/material";
import imgCoop from "../../img/coopnav.png";
import { AppContext } from "../../context/context";
import { useContext, useEffect, useState } from "react";
import ApiFetch from "../../utils/fetch";
import Btn from "../../components/btn/btn";
import Loading from "../../components/loading/loading";
import Input from "../../components/input/input";
import imgBackground from "../../img/fondo-tramite2.png";
import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";
// import { SearchNroCliente } from '../SearchNroCliente/SearchNroCliente';

const fetch = new ApiFetch();

function LoginForm() {
  const { setUser, setIsLogin } = useContext(AppContext);
  //   const [idCliente, setIdCliente] = useState('')
  const [dniCuit, setDniCuit] = useState("");
  const [loading, setLoading] = useState("");
  const [alertLogin, setAlertLogin] = useState("");
  const [showForm, setShowForm] = useState(false);
  //   const [searchNroAsociado, setSearchNroAsociado] = useState(false)

  const loginClient = async () => {
    try {
      setAlertLogin("");
      if (!dniCuit) {
        return;
      }
      setLoading(<Loading />);
      const body = JSON.stringify({
        dniCuit,
      });
      const data = await fetch.POST_PUBLIC(body, "/session/login");
      const status = data?.status;
      const message = data?.message;
      if (status === 200) {
        const token = data?.body?.token;
        const owner = data?.body?.owner;
        // Guardar el token en localStorage
        localStorage.setItem("coopTramites", JSON.stringify({ token, owner }));
        setIsLogin(true);
        setUser(owner);
      } else {
        setAlertLogin(<Alert severity="error">{message}</Alert>);
      }
      setLoading("");
    } catch (error) {
      setLoading("");
      setAlertLogin(
        <Alert severity="error">
          No fue posible ingresar, por favor intente nuevamente más tarde.
        </Alert>,
      );
    }
  };

  useEffect(() => {
    setTimeout(() => setShowForm(true), 100); // Añadir la clase después de un pequeño retraso
  }, []);

  return (
    <div className={styles.container}>
      <img src={imgBackground} alt="img" className={styles.imgBackground} />
      <div className={`${styles.form} ${showForm ? styles.show : ""}`}>
        <a href="/tramites" style={{ textDecoration: "none" }}>
          <Button
            color="success"
            variant="text"
            startIcon={<KeyboardArrowLeftRoundedIcon />}
            size="small"
          >
            Inicio
          </Button>
        </a>

        <h1>Bienvenido/a</h1>
        <img src={imgCoop} alt="img" className={styles.img} />

        <p>Ingrese su Número de asociado, DNI o CUIT para iniciar sesión.</p>
        {/* <Input color='success' label='Nro de Asociado' value={idCliente} setValue={setIdCliente} type='number' maxLength={6} size='small' /> */}
        <Input
          onKeyDownFunction={() => loginClient()}
          color="success"
          label="Nro de asociado, DNI o CUIT"
          value={dniCuit}
          setValue={setDniCuit}
          type="number"
          maxLength={12}
          size="small"
        />
        {alertLogin}
        <Btn
          size="medium"
          text="INGRESAR"
          action={() => loginClient()}
          color="success"
        />
        {/* <Btn size='medium' text='No conozco mi Nro de Asociado' action={() => setSearchNroAsociado(true)} color='warning' /> */}

        {/* {searchNroAsociado && <SearchNroCliente />} */}
      </div>
      {loading}
    </div>
  );
}

export default LoginForm;
